import { observer } from 'mobx-react'
import { Dialog } from 'antd-mobile'
import classNames from 'classnames'
import { commonUtils } from '@/helpers/commonUtils'
import styles from './PackageExpiredPopup.module.less'

export interface PackageExpiredPopupProps {
  visible: boolean
  onClose?: () => void
  onContact?: (() => void) | boolean
}

const PackageExpiredPopupContent = observer((props: PackageExpiredPopupProps) => {
  return (
    <div
      className={classNames(styles.packageExpiredPopup, {
        [styles.noContact]: typeof props.onContact !== 'function',
      })}
    >
      <div className={styles.packageExpiredPopupBg}></div>
      <div className={styles.packageExpiredPopupTitle}>套餐已过期</div>
      <div className={styles.packageExpiredPopupContent}>
        <div className={styles.packageExpiredText}>
          <p>
            您的套餐已过期，可添加<b>专属客服</b>续费
          </p>
          <p className={styles.packageExpiredTextTips}>（截图保存二维码，微信长按识别可添加）</p>
        </div>
        <div className={styles.qrcodeWrapper}>
          <img src={commonUtils.getStaticFile('images/customer_qr/pay_success.png')} alt='qrcode' />
        </div>
      </div>
    </div>
  )
})

const PackageExpiredPopup = observer((props: PackageExpiredPopupProps) => {
  return (
    <Dialog
      style={
        {
          '--max-width': '100vw',
        } as React.CSSProperties
      }
      visible={props.visible}
      onClose={props.onClose}
      closeOnMaskClick
      bodyStyle={{
        padding: 0,
        backgroundColor: 'transparent',
      }}
      content={<PackageExpiredPopupContent {...props} />}
      getContainer={() => document.body}
    />
  )
})

export default PackageExpiredPopup
